// extracted by mini-css-extract-plugin
module.exports = {"container":"high-building_container_2ADxG","noDataBox":"high-building_noDataBox_xkhGu","icon":"high-building_icon_1-GHP","chartBox":"high-building_chartBox_5XC4V"};